<template>
  <v-row>
    <v-col lg="4" md="4" sm="12" offset-lg="4" offset-md="4">
      <div align="center">
        <div class="logo-container">
          <img src="/logo.png" />
          <span>SIMSP SETDA GARUT</span>
        </div>
        <v-card class="form-container with-shadow rounded" width="100%">
          <ValidationObserver ref="observer">
            <v-form @submit.prevent="login">
              <v-card-title>SILAHKAN LOGIN</v-card-title>
              <v-card-text class="py-2">
                <ValidationProvider
                  name="username"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="username"
                    prepend-inner-icon="mdi-account"
                    label="Username"
                    :disabled="loading"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
                <ValidationProvider
                  name="password"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="password"
                    prepend-inner-icon="mdi-lock"
                    type="password"
                    label="Password"
                    :disabled="loading"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-card-text>
              <v-card-actions class="px-5 mt-5 mb-5">
                <v-layout column>
                  <v-btn type="submit" tile color="primary" :loading="loading">
                    LOGIN
                  </v-btn>
                </v-layout>
              </v-card-actions>
            </v-form>
          </ValidationObserver>
        </v-card>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import * as auth from '@/services/auth'

export default {
  data() {
    return {
      valid: false,
      loading: false,
      username: '',
      password: ''
    }
  },
  methods: {
    async login() {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        return
      }
      this.loading = true
      try {
        await auth.getAccessToken(this.$store, {
          username: this.username,
          password: this.password
        })
        const response = await auth.getUserInfo(this.$store)
        const user = response.data
        const allowedRoles = []
        if (allowedRoles.length && !allowedRoles.includes(user.role)) {
          await auth.removeAccessToken()
          this.loading = false
          throw {
            response: {
              data: { message: this.username + ' Tidak Memilik Akses' }
            }
          }
        } else {
          await window.location.reload()
          this.loading = false
        }
      } catch (err) {
        this.loading = false

        const errorMsg = err.message || 'Login Gagal'

        if (err.status === 422) {
          this.$refs.observer.setErrors(err.data)
        }

        this.$emit('handle-snackbar', errorMsg, 'error')
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.logo-container
  margin: 20px
  margin-bottom: 40px
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  img
    width: 50%
    margin-bottom: 20px
  span
    font-size: 2rem
    font-weight: bold
    color: #333

.form-container
  border: 1px solid #ffc107

.v-card__title
  justify-content: center

.v-btn
  border-radius: 15px
</style>
